import { useMemo } from "react";
import { ButtonGroup } from "react-bootstrap";
import useDashboardApi from "../../services/hooks/useDashboardApi";
import useDashboardContext from "../../services/hooks/useDashboardContext";
import { DashboardType } from "../../services/types";
import { DashboardOrganizationSearchSelect } from "./DashboardOrganizationSearchSelect";
import DashboardFilterDateRange from "./FilterDateRange";
import FilterItem from "./FilterItem";

interface Props {
	filters: string[];
	isPredefinedDate: boolean;
}

const FilterList = ({ filters, isPredefinedDate }: Props): JSX.Element => {
	const { dashboardType } = useDashboardContext();
	const { fetchDataAndApplyNewDataToDashboardState } = useDashboardApi();

	const renderFilters = useMemo(() => {
		return (
			<>
				<ButtonGroup className={"me-2 text-nowrap flex-wrap dashboard-filters-buttons"}>
					{filters.map((filter) => {
						return (
							<FilterItem
								key={filter}
								type={filter}
								fetchDataAndApplyNewDataToDashboardState={fetchDataAndApplyNewDataToDashboardState}
							/>
						);
					})}
				</ButtonGroup>
				<DashboardFilterDateRange isPredefinedDate={isPredefinedDate} />
				{dashboardType === DashboardType.GROUP_ORGANIZATIONS && <DashboardOrganizationSearchSelect />}
			</>
		);
	}, [filters, isPredefinedDate, dashboardType, fetchDataAndApplyNewDataToDashboardState]);

	return <div className="dashboard-filter">{renderFilters}</div>;
};
export default FilterList;
